import { JournalExportRepository } from "../../domain/repositories/JournalExportRepository";
import {
  JournalExportEntity,
  JournalExportParamsEntity,
} from "../../domain/entities/JournalExportEntity";
import { fetchJournalExportExcel } from "../api/journalExportsApi";

export class JournalExportRepositoryImpl implements JournalExportRepository {
  async downloadJournalExportExcel(
    params: JournalExportParamsEntity = {},
  ): Promise<JournalExportEntity> {
    const dto = await fetchJournalExportExcel({
      from_date: params.fromDate,
      to_date: params.toDate,
    });

    return {
      blob: dto.blob,
      filename: dto.filename,
    };
  }
}
